import Divider from '@mui/material/Divider';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import { Contact } from '../../../../../sic-lib/types/Contact';
import { startCall } from '../../../../../store/dialer';
import { useAppDispatch, useAppSelector } from '../../../../../store/hooks';

const useStyles = makeStyles()((theme: Theme) => ({
    item: {
        '&:hover': {
            backgroundColor: theme.palette.menuListHover.light,
        },
    },
}));

interface Props {
    anchorEl: HTMLElement | null;
    menuId: string;
    onCloseHandler: () => void;
    onDeleteHandler: () => void;
    onToggleHandler: () => void;
    fieldValue: string;
    fieldIsPrimary: boolean;
    contact: Contact;
}

export default function MenuPhoneFieldActionsRaw({
    anchorEl,
    menuId,
    onCloseHandler,
    onDeleteHandler,
    onToggleHandler,
    contact,
    fieldValue,
    fieldIsPrimary,
}: Props) {
    const { classes } = useStyles();
    const dispatch = useAppDispatch();

    const twilioDevice = useAppSelector(
        state => state.dialer?.twilioDevice?.audioDevices.length || 0,
    );

    const handleCallNumber = () => {
        dispatch(
            startCall({
                phoneNumber: fieldValue,
                contactId: contact.contactId,
                firstName: contact.firstName || '',
                lastName: contact.lastName || '',
            }),
        );
    };

    return (
        <Menu
            id={menuId}
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClick={onCloseHandler}
            onClose={onCloseHandler}
        >
            {contact.consent?.smsConsent &&
                twilioDevice > 0 &&
                (contact.consent?.expressConsent || contact.consent?.impliedConsent) && (
                    <MenuItem className={classes.item} onClick={handleCallNumber}>
                        Call number
                    </MenuItem>
                )}
            <Divider />
            <MenuItem className={classes.item} onClick={onToggleHandler}>
                Edit field
            </MenuItem>
            <MenuItem className={classes.item} onClick={onDeleteHandler}>
                Delete field
            </MenuItem>
        </Menu>
    );
}
